import { RegiaoParametroComponente } from "src/components/componentes/types";
import { ModuloListagem } from "../types";

const DEFAULT_PARAMETROS = {
  regiao_id: 0,
  potencia_inicial: 0,
  potencia_final: 0,
}

export const checarParametroRegiaoPotencia = (moduloSelecionado?: ModuloListagem | null) => {
  let status = true;
  let item: RegiaoParametroComponente = DEFAULT_PARAMETROS;
  const potencia = moduloSelecionado?.potencia || 0;
  const quantidade = moduloSelecionado?.quantidade || 0;
  const potencia_total = Number((potencia / 1000.0 * quantidade).toFixed(2));
  moduloSelecionado?.regioes_parametros?.forEach(parametro => {
    const potencia_final = parametro?.potencia_final || 0;
    const potencia_inicial = parametro?.potencia_inicial || 0;
    if (quantidade && (potencia_total < potencia_inicial || potencia_total > potencia_final)) {
      status = false;
      item = parametro;
    }
  });

  return { parametro: item, status };
};